$(document).ready(function () {
  $('.lash-size-guide-btn').click(function () {
    $('.size-guide-popup').show()
    $('body').addClass('size-guide-open')
  })
  $('.close-btn').click(function () {
    $('.size-guide-popup').hide()
    $('body').removeClass('size-guide-open')
  })
  $('.bk-btn').click(function () {
    $('.size-guide-popup').hide()
    $('body').removeClass('size-guide-open')
  })
  $('.tab-link a:first-child').addClass('active')
  $('.tab-link a').click(function () {
    var Ctab = $(this).attr('data-tab')
    $('.tab-link a').removeClass('active')
    $(this).addClass('active')
    $(Ctab).show()
    $(Ctab).siblings().hide()
  })
  $('.product-choose-option #opt-subcription').click(function () {
    if ($('#opt-subcription:checked')) {
      $('.product-form__submit').hide()
      $('.ltosubscription').show()
    }
  })
  $('.product-choose-option #opt-onetime').click(function () {
    $('.product-form__submit').show()
    $('.ltosubscription').hide()
  })
  $('.logged-out').click(function () {
    $('.login-popup').addClass('login-open')
  })

  $('.pop-close').click(function () {
    $('.login-popup').removeClass('login-open')
  })
  $('.pdetails-accordion .accordion-item button').click(function () {
    $(this).siblings('.accordion-content').slideToggle()
    $(this).parent('.accordion-item').siblings().children('.accordion-content').slideUp()
  })
  setTimeout(function () {
    $('.faq-accordion li h3').on('click', function (event) {
      $(this).siblings('.answer').slideToggle()
      $(this).toggleClass('active')
      $(this).parent('li').siblings('li').children('.answer').slideUp()
      $(this).parent('li').siblings('li').children('h3').removeClass('active')
    })
  }, 5000)
  $('.virtual-try-on').click(function () {
    $(this).siblings('.virtual-try-qr-code').addClass('enabled')
  })
  $('.close-vr').click(function () {
    $('.virtual-try-qr-code').removeClass('enabled')
  })
})

jQuery('.custom-jumptolink-section ul li a').on('click', function(e){
    e.preventDefault();
    var href = $(this).attr('href');
    $('html, body').animate({ 
        scrollTop:$(href).offset().top
    },'slow');
});
